import * as React from "react";
import { AppLayout } from "../../../layouts/app";
import { useContext, useEffect, useState } from "react";
import { CompaniesService } from "../../../services/companies";
import { CrudLayout } from "../../../layouts/crud";
import { Link } from "react-router-dom";
import { Typography, Button, IconButton } from "@mui/material";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { NotificationManager } from "react-notifications";
import { CompanyForm } from "./form";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';
import { SnackBar } from "../../../components/snackBar";
import { DataGridCompanies } from "../../../components/dataGridCompanies";


const columns = [
    {
        field: 'cnpj',
        headerName: 'CNPJ',
        flex: 1,
        editable: false,
        valueFormatter: params => cnpjMask(params?.value),
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'name',
        headerName: 'Nome',
        flex: 2.5,
        editable: false,
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'createdAt',
        headerName: 'Criada em',
        flex: 0.5,
        editable: false,
        type: 'dateTime',
        valueFormatter: params => moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
        align: 'center',
        headerAlign: 'center'
    }
];

/**
    * Function to create CNPJ mask
    * @param {string with cnpj} value 
    * @returns formatted cnpj
    */
function cnpjMask(value) {
    return value
        .replace(/\D+/g, '') // não deixa ser digitado nenhuma letra
        .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de número o primeiro com 2 digitos e o segundo de com 3 digitos, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2') // captura 2 grupos de número o primeiro e o segundo com 3 digitos, separados por /
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1') // captura os dois últimos 2 números, com um - antes dos dois números
}

export const Companies = () => {
    const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
    const [companies, setCompanies] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const companiesService = new CompaniesService();
    const [openSnackBar, setSnackBar] = useState(false);
    const [idCompany, setCompanyId] = useState();
    const [itemToEdit, setItemToEdit] = useState();

    useEffect(() => {
        const breadcrumbs = [
            <Link key="1" to="/">
                Home
            </Link>,
            <Typography key="2" color="text.primary">
                Empresas
            </Typography>,
        ];

        setBreadcrumbs(breadcrumbs);
        getCompaniesData();
    }, []);

    const getCompaniesData = () => {
        setLoadingData(true);
        setItemToEdit();
        companiesService.getCompanies().then(res => {
            setCompanies(res.data);
            setLoadingData(false);
        }).catch(error => {
            console.error(error);
            setLoadingData(false);
        });
    }

    const handleUpdate = (updatedData) => {
        companiesService.updateCompany(updatedData).then(res => {
            NotificationManager.success('Registro atualizado com sucesso.', "", 3000);
            getCompaniesData();
            setItemToEdit();
        }).catch(error => {
            NotificationManager.error('Erro ao atualizar registro.', "", 3000);
            console.error(error);
        });
    }

    const handleDelete = (id) => {
        companiesService.deleteCompany(id).then(res => {
            if (res.status === 200) {
                NotificationManager.success('Registro removido.', "", 3000);
            }
            getCompaniesData();
            setCompanyId(id);
            setSnackBar(true);
        }).catch(error => {
            NotificationManager.error('Erro ao excluir registro.', "", 3000);
            console.error(error);
        });
    }

    const handleCloseSnackBar = () => {
        setSnackBar(false);
    }

    const handleUndoOperation = () => {
        companiesService.undoCompany(idCompany).then((res) => {
            getCompaniesData();
            setSnackBar(false);
        }).catch((error) => {
            console.error(error);
        });

    }

    const handleOpenModal = (item) => {
        setItemToEdit(item);
    };

     const handleSetItemToEdit = () => {
        setItemToEdit();
    }

    const action = (
        <React.Fragment>
            <Button color="success" size="small" onClick={handleUndoOperation}  >
                DESFAZER
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSnackBar}
            >
                <CloseIcon fontSize="small" sx={{ color: 'black' }} />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>
            <AppLayout>
                <CrudLayout
                    title="Empresas"
                    formTitle='Cadastro de Empresa'
                    hasNewButton
                    form={<CompanyForm />}
                    itemToEdit={itemToEdit}
                    cleanItemToEdit={handleSetItemToEdit}
                    modalHeight={'75vh'}
                    onModalClosed={getCompaniesData}

                    children={
                        <DataGridCompanies
                            columns={columns}
                            data={companies}
                            loadingData={loadingData}
                            updateRecord={handleUpdate}
                            deleteRecord={handleDelete}
                            handleOpenModal={handleOpenModal}
                            onEditOpenModal={true}


                        />
                    }
                />
            </AppLayout>

            <SnackBar open={openSnackBar} side={"left"} action={action} />

        </>
    );
}